module.exports = __webpack_public_path__ + "static/mask-b0d34d13cbca3543637546cd9efc39dd.png";